export default __webpack_public_path__ + "static/media/cover.de675d10.jpg";